var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ChevronRight, Search as SearchIcon } from '@mui/icons-material';
import { Avatar, Box, Button, Card, Chip, IconButton, MenuItem, Pagination, Select, Stack, TextField, Typography } from '@mui/material';
import { useSnackbar } from 'notistack';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { STATUS_API } from '../../../api';
import ContainerPainel from '../../../components/container_painel';
import { FUNCIONALIDADES, PAGINAS, ROUTES } from '../../../routes';
import { getColaboradores, getContratos } from './validacao_diaria_service';
var LabelFiltro = function (_a) {
    var text = _a.text;
    return (_jsx(Typography, __assign({ variant: 'caption', fontWeight: 'bold', color: 'text.secondary', sx: { mb: 0.5, display: 'block', textTransform: 'uppercase' } }, { children: text })));
};
export function ValidacaoDiariaListar() {
    var _this = this;
    var navigate = useNavigate();
    var _a = useSnackbar(), enqueueSnackbar = _a.enqueueSnackbar, closeSnackbar = _a.closeSnackbar;
    var _b = useState({
        nome: '',
        codigo_colaborador: '',
        instituicao_id: '',
        status: '',
    }), filtros = _b[0], setFiltros = _b[1];
    var _c = useState(1), pagina = _c[0], setPagina = _c[1];
    var _d = useState(15), porPagina = _d[0], setPorPagina = _d[1];
    var _e = useState([]), colaboradores = _e[0], setColaboradores = _e[1];
    var _f = useState([]), contratos = _f[0], setContratos = _f[1];
    var _g = useState(0), totalGeral = _g[0], setTotalGeral = _g[1];
    var _h = useState(false), loading = _h[0], setLoading = _h[1];
    var totalGeralRegistros = colaboradores.reduce(function (acc, current) { return acc + current.total_batidas; }, 0);
    var getCodigoColaborador = function (colaborador) {
        var _a, _b;
        var codigo = ((_a = colaborador.reeducando) === null || _a === void 0 ? void 0 : _a.codigo) || colaborador.codigo || colaborador.codigo_colaborador;
        if (codigo)
            return codigo;
        var idColaborador = ((_b = colaborador.reeducando) === null || _b === void 0 ? void 0 : _b.id) || colaborador.reeducando_id || colaborador.id;
        return idColaborador ? "FUNAC - ".concat(idColaborador) : 'N/A';
    };
    var carregarDados = function (showToast, clearFiltros) {
        if (showToast === void 0) { showToast = false; }
        if (clearFiltros === void 0) { clearFiltros = false; }
        return __awaiter(_this, void 0, void 0, function () {
            var snackId, filtrosAplicar, response, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setLoading(true);
                        snackId = null;
                        if (showToast) {
                            snackId = enqueueSnackbar('Buscando registros no servidor...', {
                                variant: 'info',
                                persist: true,
                                anchorOrigin: { vertical: 'top', horizontal: 'right' },
                            });
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 6]);
                        filtrosAplicar = clearFiltros
                            ? {
                                nome: '',
                                codigo_colaborador: '',
                                instituicao_id: '',
                                status: '',
                            }
                            : filtros;
                        return [4 /*yield*/, getColaboradores({ page: pagina - 1, pageSize: porPagina }, filtrosAplicar)];
                    case 2:
                        response = _a.sent();
                        if (response.Status === STATUS_API.OK) {
                            setColaboradores(response.dados);
                            setTotalGeral(response.total_registros);
                        }
                        return [3 /*break*/, 6];
                    case 3:
                        error_1 = _a.sent();
                        console.error('Erro ao carregar colaboradores:', error_1);
                        enqueueSnackbar('Erro ao buscar colaboradores. Tente novamente.', {
                            variant: 'error',
                            anchorOrigin: { vertical: 'top', horizontal: 'right' },
                        });
                        return [3 /*break*/, 6];
                    case 4: return [4 /*yield*/, new Promise(function (resolve) { return setTimeout(resolve, 2100); })];
                    case 5:
                        _a.sent();
                        setLoading(false);
                        if (snackId)
                            closeSnackbar(snackId);
                        return [7 /*endfinally*/];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    var carregarContratos = function () { return __awaiter(_this, void 0, void 0, function () {
        var response, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, getContratos()];
                case 1:
                    response = _a.sent();
                    if (response.Status === STATUS_API.OK) {
                        setContratos(response.dados || []);
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_2 = _a.sent();
                    console.error('Erro ao carregar contratos:', error_2);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        carregarContratos();
    }, []);
    useEffect(function () {
        carregarDados();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pagina, porPagina]);
    var handleLimparFiltros = function () {
        setFiltros({
            nome: '',
            codigo_colaborador: '',
            instituicao_id: '',
            status: '',
        });
        setPagina(1);
        enqueueSnackbar('Filtros limpos com sucesso.', {
            variant: 'success',
            anchorOrigin: { vertical: 'top', horizontal: 'right' },
        });
        if (pagina === 1) {
            carregarDados(false, true);
        }
    };
    var handlePesquisar = function () {
        setPagina(1);
        carregarDados(true);
    };
    var handleExpandir = function (colaborador) {
        navigate("".concat(ROUTES.GF_VALIDACAO_DIARIA, "/detalhes/").concat(colaborador.reeducando_id || colaborador.id), { state: { reeducandoInfo: colaborador } });
    };
    return (_jsx(ContainerPainel, __assign({ pagina_acima: PAGINAS.GF_PRIMEIRA_PAGINA, pagina: PAGINAS.GF_VALIDACAO_DIARIA, pagina_especifica_permissao: FUNCIONALIDADES.GF_VALIDACAO_DIARIA, titulo_pagina: 'Valida\u00E7\u00E3o Di\u00E1ria de Ponto', backgroundColor: '#f8f9fa' }, { children: _jsxs(Box, __assign({ sx: { minWidth: '100%' } }, { children: [_jsx(Card, __assign({ variant: 'outlined', sx: {
                        p: 2,
                        mb: 3,
                        borderRadius: 1.5,
                        borderColor: '#e0e0e0',
                        boxShadow: 'none',
                    } }, { children: _jsxs(Box, __assign({ sx: {
                            display: 'flex',
                            flexWrap: 'wrap',
                            gap: 2,
                            alignItems: 'flex-end',
                        } }, { children: [_jsxs(Box, __assign({ sx: { flex: { xs: '1 1 100%', sm: '1 1 48%', md: '1 1 24%' } } }, { children: [_jsx(LabelFiltro, { text: 'NOME' }), _jsx(TextField, { placeholder: 'Buscar por nome...', variant: 'outlined', size: 'small', fullWidth: true, value: filtros.nome, onChange: function (e) {
                                            var val = e.target.value.replace(/[^a-zA-ZáéíóúàèìòùâêîôûãõçÁÉÍÓÚÀÈÌÒÙÂÊÎÔÛÃÕÇ\s]/g, '');
                                            setFiltros(__assign(__assign({}, filtros), { nome: val }));
                                        }, sx: { backgroundColor: 'white' } })] })), _jsxs(Box, __assign({ sx: { flex: { xs: '1 1 100%', sm: '1 1 48%', md: '1 1 16%' } } }, { children: [_jsx(LabelFiltro, { text: 'C\u00D3DIGO DO COLABORADOR' }), _jsx(TextField, { placeholder: 'Ex.: FUNAC - 1029', variant: 'outlined', size: 'small', fullWidth: true, value: filtros.codigo_colaborador, inputProps: { maxLength: 13 }, onChange: function (e) {
                                            var val = e.target.value.replace(/[^a-zA-Z0-9\s-]/g, '').slice(0, 13);
                                            setFiltros(__assign(__assign({}, filtros), { codigo_colaborador: val }));
                                        }, sx: { backgroundColor: 'white' } })] })), _jsxs(Box, __assign({ sx: { flex: { xs: '1 1 100%', sm: '1 1 100%', md: '1 1 24%' } } }, { children: [_jsx(LabelFiltro, { text: 'CONTRATO' }), _jsxs(Select, __assign({ displayEmpty: true, size: 'small', fullWidth: true, value: filtros.instituicao_id, onChange: function (e) { return setFiltros(__assign(__assign({}, filtros), { instituicao_id: e.target.value })); }, sx: { backgroundColor: 'white' } }, { children: [_jsx(MenuItem, __assign({ value: '' }, { children: "Todos os Contratos" })), contratos.map(function (c) { return (_jsx(MenuItem, __assign({ value: c.instituicao_id || c.contrato_id }, { children: c.empresa_nome }), c.instituicao_id || c.contrato_id)); })] }))] })), _jsxs(Box, __assign({ sx: { flex: { xs: '1 1 100%', sm: '1 1 48%', md: '1 1 16%' } } }, { children: [_jsx(LabelFiltro, { text: 'STATUS' }), _jsxs(Select, __assign({ displayEmpty: true, size: 'small', fullWidth: true, value: filtros.status, onChange: function (e) { return setFiltros(__assign(__assign({}, filtros), { status: e.target.value })); }, sx: { backgroundColor: 'white' } }, { children: [_jsx(MenuItem, __assign({ value: '' }, { children: "Todos" })), _jsx(MenuItem, __assign({ value: 'PENDENTE' }, { children: "Pendente" })), _jsx(MenuItem, __assign({ value: 'REGULAR' }, { children: "Regular" })), _jsx(MenuItem, __assign({ value: 'ALERTA_BIOMETRICO' }, { children: "Alerta Biom\u00E9trico" })), _jsx(MenuItem, __assign({ value: 'ALERTA_IDENTIDADE' }, { children: "Alerta Identidade" })), _jsx(MenuItem, __assign({ value: 'AUSENCIA_PARCIAL' }, { children: "Aus\u00EAncia Parcial" })), _jsx(MenuItem, __assign({ value: 'AUSENCIA_TOTAL' }, { children: "Aus\u00EAncia Total" })), _jsx(MenuItem, __assign({ value: 'EM_ANALISE' }, { children: "Em An\u00E1lise" })), _jsx(MenuItem, __assign({ value: 'APROVADO' }, { children: "Aprovado" })), _jsx(MenuItem, __assign({ value: 'REPROVADO' }, { children: "Reprovado" }))] }))] })), _jsxs(Box, __assign({ sx: {
                                    flex: 1,
                                    display: 'flex',
                                    gap: 1,
                                    flexWrap: 'wrap',
                                    minWidth: 250,
                                    justifyContent: { xs: 'flex-start', md: 'flex-end' },
                                } }, { children: [_jsx(Button, __assign({ variant: 'outlined', onClick: handleLimparFiltros, sx: {
                                            height: 40,
                                            flex: 1,
                                            minWidth: 120,
                                            fontSize: 12,
                                            borderColor: '#d1d5db',
                                            color: '#4b5563',
                                            textTransform: 'none',
                                            backgroundColor: '#fff',
                                            '&:hover': {
                                                backgroundColor: '#f9fafb',
                                                borderColor: '#d1d5db',
                                            },
                                        } }, { children: "Limpar Filtros" })), _jsx(Button, __assign({ variant: 'contained', onClick: handlePesquisar, disableElevation: true, startIcon: _jsx(SearchIcon, {}), sx: {
                                            height: 40,
                                            flex: 1,
                                            minWidth: 120,
                                            fontSize: 12,
                                            backgroundColor: '#2196f3',
                                            color: 'white',
                                            textTransform: 'none',
                                            '&:hover': {
                                                backgroundColor: '#1976d2',
                                            },
                                        } }, { children: "Pesquisar" }))] }))] })) })), _jsxs(Box, __assign({ sx: { display: 'flex', justifyContent: 'space-between', mb: 2, alignItems: 'center', px: 0.5 } }, { children: [_jsxs(Typography, __assign({ variant: 'body2', sx: { fontWeight: 600, color: '#4b5563' } }, { children: [colaboradores.length, " colaboradores \u2022 ", totalGeral, " registros encontrados"] })), _jsx(Typography, __assign({ variant: 'body2', sx: { color: '#9ca3af' } }, { children: "Ordem alfab\u00E9tica" }))] })), _jsxs(Stack, __assign({ spacing: 2, sx: { mb: 4, opacity: loading ? 0.6 : 1, transition: 'opacity 0.2s' } }, { children: [colaboradores.map(function (colaborador) {
                            var _a, _b, _c, _d;
                            var nome = (((_a = colaborador.reeducando) === null || _a === void 0 ? void 0 : _a.nome) || colaborador.reeducando_nome || colaborador.nome || 'N/A').toUpperCase();
                            var codigoColaborador = getCodigoColaborador(colaborador);
                            var contrato = ((_b = colaborador.contrato) === null || _b === void 0 ? void 0 : _b.nome) || colaborador.empresa_nome || (typeof colaborador.contrato === 'string' ? colaborador.contrato : 'N/A');
                            var registros = (_c = colaborador.total_batidas) !== null && _c !== void 0 ? _c : 0;
                            var iniciais = nome
                                .split(' ')
                                .map(function (n) { return n[0]; })
                                .join('')
                                .substring(0, 2);
                            return (_jsxs(Card, __assign({ variant: 'outlined', sx: {
                                    p: 2,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                    boxShadow: 'none',
                                    borderColor: '#e5e7eb',
                                    borderRadius: 2,
                                    cursor: 'pointer',
                                    '&:hover': { backgroundColor: '#f9fafb' },
                                }, onClick: function () { return handleExpandir(colaborador); } }, { children: [_jsxs(Box, __assign({ sx: { display: 'flex', alignItems: 'center', gap: 2 } }, { children: [_jsx(Avatar, __assign({ sx: { bgcolor: '#e5e7eb', color: '#4b5563', fontWeight: 'bold', width: 36, height: 36, fontSize: '0.875rem' } }, { children: iniciais })), _jsxs(Box, { children: [_jsx(Typography, __assign({ variant: 'subtitle2', sx: { fontWeight: 700, color: '#1f2937', lineHeight: 1.2 } }, { children: nome })), _jsxs(Typography, __assign({ variant: 'caption', sx: { color: '#9ca3af' } }, { children: ["C\u00F3digo: ", codigoColaborador, " - ", contrato] }))] })] })), _jsxs(Box, __assign({ sx: { display: 'flex', alignItems: 'center', gap: 2 } }, { children: [_jsx(Chip, { label: "".concat(registros, " registros"), size: 'small', sx: { backgroundColor: '#f3f4f6', color: '#6b7280', fontWeight: 500, fontSize: '0.75rem', height: 24 } }), _jsx(IconButton, __assign({ size: 'small', disableRipple: true, sx: { color: '#9ca3af', p: 0 } }, { children: _jsx(ChevronRight, {}) }))] }))] }), (_d = colaborador.id) !== null && _d !== void 0 ? _d : "sem-ponto-".concat(colaborador.reeducando_id)));
                        }), loading && (_jsx(Box, __assign({ sx: { py: 4, textAlign: 'center' } }, { children: _jsx(Typography, __assign({ variant: 'body2', color: 'text.secondary' }, { children: "Carregando..." })) }))), colaboradores.length === 0 && !loading && (_jsx(Box, __assign({ sx: { py: 4, textAlign: 'center' } }, { children: _jsx(Typography, __assign({ variant: 'body2', color: 'text.secondary' }, { children: "Nenhum colaborador encontrado." })) })))] })), _jsxs(Card, __assign({ variant: 'outlined', sx: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', p: 2, borderRadius: 2, borderColor: '#e5e7eb', boxShadow: 'none' } }, { children: [_jsxs(Typography, __assign({ variant: 'body2', sx: { color: '#6b7280' } }, { children: ["Mostrando ", colaboradores.length, " colaboradores (", totalGeralRegistros, " registros) de ", totalGeral, " no total"] })), _jsxs(Box, __assign({ sx: { display: 'flex', alignItems: 'center', gap: 3 } }, { children: [_jsxs(Box, __assign({ sx: { display: 'flex', alignItems: 'center', gap: 1 } }, { children: [_jsx(Typography, __assign({ variant: 'body2', sx: { color: '#6b7280' } }, { children: "Por p\u00E1gina:" })), _jsxs(Select, __assign({ value: porPagina, onChange: function (e) { return setPorPagina(Number(e.target.value)); }, size: 'small', variant: 'standard', disableUnderline: true, sx: { fontSize: '0.875rem', fontWeight: 500, color: '#1f2937', padding: 0 } }, { children: [_jsx(MenuItem, __assign({ value: 15 }, { children: "15" })), _jsx(MenuItem, __assign({ value: 30 }, { children: "30" })), _jsx(MenuItem, __assign({ value: 50 }, { children: "50" }))] }))] })), _jsx(Pagination, { count: Math.ceil(totalGeral / porPagina), page: pagina, onChange: function (_, value) { return setPagina(value); }, showFirstButton: true, showLastButton: true, shape: 'rounded', size: 'small', sx: {
                                        '& .MuiPaginationItem-root': {
                                            borderColor: '#e5e7eb',
                                        },
                                    }, variant: 'outlined' })] }))] }))] })) })));
}
